import { BitfNetEnvelopeMapper } from '@common/libs/bitforce/core/parsers/net-parser';

export class AppEnvelopeMapper extends BitfNetEnvelopeMapper {}
